import { Tooltip } from 'antd'
import React from 'react'

function OptionButton(){

    return (

        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_284_3963)">
                <path d="M10.7912 14.0003H7.60268C6.51001 14.0194 5.42533 13.8109 4.41764 13.388C3.40994 12.9651 2.5013 12.3371 1.74952 11.5439C1.1134 10.8485 0.631416 10.0265 0.335159 9.13177C0.0389024 8.23707 -0.0649418 7.28986 0.0304324 6.35223C0.175151 4.8266 0.815542 3.39035 1.85369 2.26308C2.89184 1.13582 4.27061 0.37957 5.77918 0.109977C6.77024 -0.0738491 7.78979 -0.0347403 8.76386 0.224465C9.73792 0.483671 10.6421 0.956472 11.4107 1.60856C12.2244 2.29258 12.878 3.14691 13.3253 4.11122C13.7726 5.07553 14.0028 6.1263 13.9995 7.18931V10.792C13.9984 11.6425 13.6601 12.458 13.0586 13.0594C12.4572 13.6609 11.6418 13.9992 10.7912 14.0003ZM7.01702 1.75031C5.70714 1.74918 4.44393 2.23661 3.47433 3.11732C2.50473 3.99803 1.89845 5.20869 1.77402 6.51264C1.70265 7.2082 1.77904 7.91099 1.99819 8.57497C2.21734 9.23895 2.5743 9.84914 3.04568 10.3656C3.63318 10.9784 4.34164 11.4624 5.12612 11.7868C5.9106 12.1113 6.75396 12.2691 7.60268 12.2503H10.7912C11.178 12.2503 11.5489 12.0967 11.8224 11.8232C12.0959 11.5497 12.2495 11.1788 12.2495 10.792V7.18931C12.2522 6.38187 12.0778 5.58366 11.7385 4.85093C11.3993 4.11821 10.9035 3.4688 10.286 2.94848C9.37336 2.17331 8.21444 1.74854 7.01702 1.75031ZM6.99952 3.50031C6.76745 3.50031 6.54489 3.5925 6.3808 3.75659C6.2167 3.92069 6.12452 4.14325 6.12452 4.37531C6.12452 4.60737 6.2167 4.82993 6.3808 4.99403C6.54489 5.15812 6.76745 5.25031 6.99952 5.25031C7.23158 5.25031 7.45414 5.15812 7.61823 4.99403C7.78233 4.82993 7.87452 4.60737 7.87452 4.37531C7.87452 4.14325 7.78233 3.92069 7.61823 3.75659C7.45414 3.5925 7.23158 3.50031 6.99952 3.50031ZM7.29118 11.0836C7.05912 11.0836 6.83656 10.9915 6.67246 10.8274C6.50837 10.6633 6.41618 10.4407 6.41618 10.2086V7.58364H6.12452C5.89245 7.58364 5.66989 7.49146 5.5058 7.32736C5.3417 7.16327 5.24952 6.94071 5.24952 6.70864C5.24952 6.47658 5.3417 6.25402 5.5058 6.08992C5.66989 5.92583 5.89245 5.83364 6.12452 5.83364H6.70785C7.09462 5.83364 7.46556 5.98729 7.73905 6.26078C8.01254 6.53427 8.16618 6.9052 8.16618 7.29198V10.2086C8.16618 10.4407 8.074 10.6633 7.9099 10.8274C7.74581 10.9915 7.52325 11.0836 7.29118 11.0836Z" fill="#013A81" fill-opacity="0.4"/>
            </g>
            <defs>
                <clipPath id="clip0_284_3963">
                    <rect width="14" height="14" fill="white"/>
                </clipPath>
            </defs>
        </svg>

    )
}

const IconInfo = ({descriptionInfo=""}) => {

    return (
        <Tooltip
            placement='bottomLeft'
            title={ <div>
                Al activar esta opción podrás duplicar <b>una sola vez</b> el perfil y realizar modificaciones
                </div>
            }
            showArrow={false}
            overlayInnerStyle={{padding:'10px 14px'}}
        >
            <div style={{margin:'0 0 0 20px', display:'flex',alignItems:'center'}}>
                <OptionButton/>
            </div>
        </Tooltip>
    )
}

export default IconInfo